module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-dropzone",
    class: {
      'is-active': !_vm.file
    }
  }, [(!_vm.file) ? _c('div', {
    staticClass: "upload-dropzone--text"
  }, [_c('div', {
    staticClass: "upload-dropzone--icon"
  }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.upload.dropzone_message')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.file) ? _c('div', {
    staticClass: "upload-dropzone--text"
  }, [_vm._v("\n    " + _vm._s(_vm.file.name) + " / " + _vm._s(_vm.formatBytes(_vm.file.size, 2)) + " "), _c('i', {
    staticClass: "icon icon-x",
    attrs: {
      "title": _vm.$t('ui.upload.empty_file')
    },
    on: {
      "click": _vm.emptyFile
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.file) ? _c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.fileUpload
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a0c4c28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/UploadField.vue
// module id = 1968
// module chunks = 0